export default "__VITE_ASSET__BSusWblk__"